export type screenType = "DESKTOP" | "TABLET" | "MOBILE";
export const DESKTOP_MIN_WIDTH = 1240;
export const TABLET_MIN_WIDTH = 834;
export const LIKE_BUTTON_HEIGHT = 20;